import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { translationChunksConfig } from '@spartacus/assets';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { OpenStatementsComponent } from './open-statements/open-statements.component';
import { FormatNegativeValuePipe } from './statement-display/format-negative-value.pipe';
import { StatementDisplayComponent } from './statement-display/statement-display.component';

@NgModule({
  declarations: [
    OpenStatementsComponent,
    StatementDisplayComponent,
    FormatNegativeValuePipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    NgbModule,
    FontAwesomeModule,
    ConfigModule.withConfig({
      cmsComponents: {
        StatementTopBodyComponent: {
          component: OpenStatementsComponent,
        },
      },
      i18n: {
        backend: { loadPath: 'i18n-assets/{{lng}}/{{ns}}.json' },
      },
      chunks: translationChunksConfig,
    } as CmsConfig),
  ],
  providers: [NgbActiveModal],
  exports: [OpenStatementsComponent, StatementDisplayComponent],
})
export class StatementsModule {}
